import { render, staticRenderFns } from "./Mqttbox.vue?vue&type=template&id=be436422&scoped=true"
import script from "./Mqttbox.vue?vue&type=script&lang=js"
export * from "./Mqttbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be436422",
  null
  
)

export default component.exports